<!-- 企业级-业务领域-仓储业务-产品管理 -->
<template>
  <div class="mainArea CProductManage">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <el-tabs v-model="tabActive" @tab-click="tabChange" class="tabList" stretch>
          <el-tab-pane label="产品信息" name="1">
            <CProductInfo v-if="tabActive == '1'"></CProductInfo>
          </el-tab-pane>
          <el-tab-pane label="产品属性" name="2">
            <CProductAttr v-if="tabActive == '2'"></CProductAttr>
          </el-tab-pane>
        </el-tabs>
      </div>

      
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import CProductInfo from "./CProductInfo.vue"
  import CProductAttr from "./CProductAttr.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"

  export default {
    name: 'CProductManage',
    components: {
      CBreadCrumb,
      CProductInfo,
      CProductAttr,
    },
    data() {
      return {
        tabActive:'1',
      };
    },
    mounted(){

    },
    created: async function () {
      
    },
    methods: {
      //tabs切换
      tabChange(tab, event) {
        console.log(tab, event);
      },
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CProductManage{
  .mainBodyContent{
    padding: 0;
  }
  .tabList{
    width: 100%;
    // tabs标签
    .el-tabs__header {
      width: 100%;
      margin-bottom: 0;
      box-sizing: border-box;
      border-bottom: 1px solid #E4E7ED;
      .el-tabs__nav-wrap {
        padding-left: 20px;
        width: 360px;
      }
      .el-tabs__item {
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/CProductManage/CProductManage.vue